import { type FunctionComponent, useCallback } from "react";
import { graphql, useFragment } from "react-relay";

import { EntityLink } from "scmp-app/components/entity-link";
import { useSearchContext } from "scmp-app/components/search/contexts";
import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";
import type { SearchEvent } from "scmp-app/components/tracking/google-analytics-4/types";
import type { itemTopicSearchResultListItemTopic$key } from "scmp-app/queries/__generated__/itemTopicSearchResultListItemTopic.graphql";

import { Container, TitleContainer, TopicTitle } from "./styles";

export type Props = {
  className?: string;
  reference: itemTopicSearchResultListItemTopic$key;
};

export const TopicSearchResultListItem: FunctionComponent<Props> = ({ className, reference }) => {
  const topic = useFragment(
    graphql`
      fragment itemTopicSearchResultListItemTopic on Topic {
        entityId
        name
        ...entityLink
      }
    `,
    reference,
  );

  const { currentValue, initialSearchId } = useSearchContext();

  const handleTopicClick = useCallback(() => {
    // GA4 21.2.1
    sendGA4Tracking({
      action: "click",
      category: "search",
      customized_parameters: {
        search_id: initialSearchId,
        search_text: currentValue,
        topic_id: topic.entityId,
      },
      subcategory: "result",
    } as SearchEvent);
  }, [currentValue, initialSearchId, topic.entityId]);

  return (
    <Container className={className}>
      <EntityLink onClick={handleTopicClick} reference={topic}>
        <TitleContainer>
          <TopicTitle>{topic.name}</TopicTitle>
        </TitleContainer>
      </EntityLink>
    </Container>
  );
};

TopicSearchResultListItem.displayName = "TopicSearchResultListItem";
